import { ICompanyData } from '@/types/checklist.types';
import { format } from 'date-fns';
import { id as idLocale } from 'date-fns/locale';

interface ChecklistDetailProps {
  companyData: ICompanyData;
}

export const ChecklistDetail = ({ companyData }: ChecklistDetailProps) => {
  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'dd MMMM yyyy', { locale: idLocale });
    } catch {
      return dateString;
    }
  };

  const detailItems = [
    {
      label: 'Perusahaan',
      value: companyData.business_name || companyData.business_legal_name || '-',
    },
    {
      label: 'Pemilik',
      value: companyData.client_name || '-',
    },
    {
      label: 'Tanggal Mulai/Berakhir',
      value:
        companyData.start_date && companyData.end_date
          ? `${formatDate(companyData.start_date)} - ${formatDate(companyData.end_date)}`
          : '-',
    },
    {
      label: 'Nomor WhatsApp',
      value: companyData.owner_phone || '-',
    },
  ];

  return (
    <div className="space-y-4">
      {detailItems.map((item, index) => (
        <div key={index} className="flex items-start">
          <div className="w-48 flex-shrink-0">
            <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{item.label}</span>
          </div>
          <div className="flex-1">
            <span className="text-sm text-gray-900 dark:text-gray-100">{item.value}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
